/**
 * Runtime standalone-surface guard for the account-export UI.
 *
 * The identity methods behind export (`exportKeystore` / `revealSolanaSecret`,
 * see `packages/identity/src/IdentityImpl.ts`) don't know which surface they're
 * called from — one `WalletProvider` wraps both the `/settings` route and the
 * `/embed/wallet` popup route (see `src/routes/AppRouter.tsx`), and the same
 * `IdentityImpl` instance backs both. The primary boundary is that only the
 * `/settings` route mounts `ExportAccount` at all. This helper is a
 * belt-and-suspenders runtime check atop that route separation, in case
 * `ExportAccount` (or a component that renders it) is ever reachable from the
 * embed surface by accident.
 *
 * Takes an optional `pathname` (defaulting to `window.location.pathname`) so
 * it's testable without touching `window.location`.
 */
export function isEmbedSurface(pathname: string = window.location.pathname): boolean {
  return pathname === '/embed' || pathname.startsWith('/embed/');
}
